import React from 'react';

const IconStarFilled = ({ size = "16px" }) => (
  <img src="/images/IconStarFilled.svg" alt="Star Filled" height={size} width={size} />
);

export default IconStarFilled;
